import React from 'react';
import PropTypes from 'prop-types';

import css from './row-as-form-element.css';

const RowAsFormElement = ({
  children,
}) => {
  return (
    <div className={css.rowAsFormElement}>
      { children }
    </div>
  );
};

RowAsFormElement.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RowAsFormElement;
